import { LayoutState } from './types'

export default {
  getCurrency: (state: LayoutState) => state.currency,
  getLang: (state: LayoutState) => state.lang,
  isGrossSelected: (state: LayoutState) => state.priceGross,
  priceType: (_state: LayoutState, getters: any) => (getters && getters.isGrossSelected ? 'GROSS' : 'NET'),
}
